import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode; title?: string };
type State = { error: Error | null };

/** Catches render crashes so one bad widget cannot blank the whole Coach tab. */
export class CoachErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[CoachErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="mx-auto w-full max-w-2xl space-y-4 px-4 py-8">
          <h1 className="font-display text-xl font-bold text-[var(--text-primary)]">
            {this.props.title ?? 'Coach'}
          </h1>
          <div className="rounded-2xl border border-red-500/30 bg-red-500/10 px-4 py-4">
            <p className="text-sm font-semibold text-red-100">Something went wrong loading Coach.</p>
            <p className="mt-2 text-xs text-red-200/80 break-words">
              {this.state.error.message || 'Unknown error'}
            </p>
            <button
              type="button"
              className="mt-4 rounded-xl bg-white/10 px-4 py-2 text-sm font-semibold text-white"
              onClick={() => this.setState({ error: null })}
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
